import React from "react";
import Button from "@components/button";
import ErrorSVGIcon from "../../../../img/error.svg";
import { useStore } from "../../../../store";
import i18nStrings from "./strings";
import {
  ErrorMessageStyles,
  ErrorMessageTitle,
  ErrorMessageText,
  ErrorMessageContent,
  ErrorMessageIcon,
} from "./ErrorMessage.styles";

const ErrorMessage = () => {
  const { localeModule } = useStore();
  const { locale } = localeModule;
  const strings = i18nStrings[locale];

  const handleReloader = () => {
    document.location.reload();
  };

  return (
    <ErrorMessageStyles>
      <ErrorMessageIcon>
        <img alt="" src={ErrorSVGIcon} />
      </ErrorMessageIcon>
      <ErrorMessageContent>
        <ErrorMessageTitle>{strings.errorMessageTitle}</ErrorMessageTitle>
        <ErrorMessageText>{strings.errorMessageText}</ErrorMessageText>
        <Button onClick={handleReloader}>{strings.reloadPage}</Button>
      </ErrorMessageContent>
    </ErrorMessageStyles>
  );
};

export default ErrorMessage;
